import React from 'react';

import { SxProps } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';

import DropZone from '@ts-core/core/components/DropZone';
import FileProgressBar from '@ts-core/core/components/FileProgressBar';

interface ImageUploaderProps {
  children?: React.ReactNode;
  sx?: SxProps;

  onFileSelected: (file: File) => void;
  selectedFileName?: string;

  uploading?: boolean;
  progress: number;
  uploadError?: string;

  acceptedFiles: string[];
}

const ImageUploader = (props: ImageUploaderProps) => {
  const { children, sx, onFileSelected, uploading = false, progress, acceptedFiles, uploadError, selectedFileName } = props;

  return (
    <Box sx={sx}>
      <DropZone
        onDropFile={onFileSelected}
        message="Arrastra aquí el archivo multimedia que desees subir o hace click para seleccionar uno."
        accept={acceptedFiles.join(',')}
      >
        {uploading && <FileProgressBar sx={{ mt: 2 }} progress={progress * 100} fileName={selectedFileName} />}
        {children}
      </DropZone>
      {uploadError && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {uploadError}
        </Alert>
      )}
    </Box>
  );
};

export default ImageUploader;
